<template>
  <div class="footer">
    <div class="u-width-wrapper">
      <div class="footer__social-container">
        <ul class="footer__social">
          <li class="icon icon--circle icon--flag-eu">
            <a title="Call Product Focus (EU)" href="tel:+44 (0) 207 099 5567"
              >+44 (0) 207 099 5567</a
            >
          </li>
          <li class="icon icon__awesome icon--fal icon--email">
            <ContentTypeIcon :content-type="'email'" />
            <a href="mailto:info@productfocus.com" title="Email Product Focus"
              >info@productfocus.com</a
            >
          </li>
          <li class="social__icons">
            <a
              href="https://twitter.com/ProductFocus"
              target="_blank"
              title="Twitter profile"
              rel="noopener noreferrer"
            >
              <ContentTypeIcon :content-type="'twitter'" />
            </a>
            <a
              href="https://www.facebook.com/productfocus"
              target="_blank"
              title="Facebook profile"
              rel="noopener noreferrer"
            >
              <ContentTypeIcon :content-type="'facebook'" />
            </a>
            <a
              href="https://www.linkedin.com/company/product-focus/"
              target="_blank"
              title="Linkedin profile"
              rel="noopener noreferrer"
            >
              <ContentTypeIcon :content-type="'linkedin'" />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="u-width-wrapper"
      v-html="sectionContent?.content"
      @click="interceptLinkClicks"
    />
  </div>
</template>

<script setup>
  const pageContentStore = usePageContentStore();
  const sectionContent = pageContentStore.getFooter;
</script>

<style lang="scss" scoped>
  .footer {
    background: $pfgreen;
    font-size: 0.8125rem;
    color: $white;
    padding-top: 30px;
    padding-bottom: 30px;
    margin-top: auto;
  }

  p {
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }
  }
</style>
